import { useEffect, useState } from 'react';
import { api } from '../api';

interface Ticket {
  id: string;
  subject: string;
  category: string | null;
  priority: string;
  status: string;
}

const STATUSES = ['open', 'in_progress', 'resolved', 'closed'];

export function SupportPage() {
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [priority, setPriority] = useState('normal');

  async function load() {
    setTickets(await api.get<Ticket[]>('/api/tickets').catch(() => []));
  }
  useEffect(() => {
    void load();
  }, []);

  async function raise() {
    if (!subject.trim()) return;
    await api.post('/api/tickets', { subject, description, priority });
    setSubject('');
    setDescription('');
    await load();
  }
  async function setStatus(t: Ticket, status: string) {
    await api.patch(`/api/tickets/${t.id}`, { status });
    await load();
  }

  return (
    <div className="card">
      <h1>Support</h1>
      <p className="muted">Raise a ticket to the IT admin.</p>

      <div className="stack">
        <input placeholder="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} />
        <textarea placeholder="Describe the issue" value={description} onChange={(e) => setDescription(e.target.value)} />
        <div className="row">
          <select value={priority} onChange={(e) => setPriority(e.target.value)}>
            <option value="low">Low</option>
            <option value="normal">Normal</option>
            <option value="high">High</option>
          </select>
          <button className="btn btn-primary" onClick={() => void raise()}>Raise ticket</button>
        </div>
      </div>

      <table className="grid">
        <thead><tr><th>Subject</th><th>Priority</th><th>Status</th></tr></thead>
        <tbody>
          {tickets.map((t) => (
            <tr key={t.id}>
              <td>{t.subject}</td>
              <td>{t.priority}</td>
              <td>
                <select value={t.status} onChange={(e) => void setStatus(t, e.target.value)}>
                  {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </td>
            </tr>
          ))}
          {tickets.length === 0 && <tr><td colSpan={3} className="empty">No tickets.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
